<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
import CiSkeletonFavoriteTile from '@/components/skeleton/CiSkeletonFavoriteTile.vue';
</script>

<template>
  <div class="container">
    <div class="mb-5 mt-2 text-center">
      <CiSkeletonItem class="mx-auto h-[30px] w-[45%] md:hidden" />
    </div>
    <div class="grid grid-cols-12 md:gap-x-[15px]">
      <div class="col-span-12 md:col-span-6 lg:col-span-4">
        <CiSkeletonFavoriteTile />
      </div>
      <div class="hidden md:col-span-6 md:block lg:col-span-4">
        <CiSkeletonFavoriteTile />
      </div>
      <div class="hidden lg:col-span-4 lg:block">
        <CiSkeletonFavoriteTile />
      </div>
    </div>
  </div>
</template>
